// components/StudentPortal/Assistant/StudentAssistant.js
// Asistente virtual del alumno (S5). Usa el asistente REAL de la ruta (titulo +
// miniatura), no un "EMMA" hardcodeado. Renderiza: card en el home + burbuja
// flotante + panel de chat (reutiliza AssistantEducaChat + Assistant_createthread).
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../hooks";
import { Assistant_createthread } from "../../../api/AssistantEducaAPI";
import { AssistantEducaChat } from "../../AssistantEduca";
import noAvatar from "../../../assets/png/Educa360Logo.png";
import styles from "./StudentAssistant.module.scss";

export function StudentAssistant({ assistant, label, dark, bubbleOnly }) {
  const { t } = useTranslation("students");
  const { accessToken } = useAuth();
  const [open, setOpen] = useState(false);
  const [threadId, setThreadId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  if (!assistant) return null;

  const avatar = assistant.miniature || noAvatar;

  const connect = async () => {
    setLoading(true);
    setFailed(false);
    try {
      const id = await Assistant_createthread(accessToken, assistant.id);
      if (id) setThreadId(id);
      else setFailed(true);
    } catch (_e) {
      setFailed(true);
    } finally {
      setLoading(false);
    }
  };

  const openChat = () => {
    setOpen(true);
    if (!threadId && !loading) connect();
  };

  return (
    <>
      {/* Card (oculta en modo bubbleOnly, p.ej. dentro de una tarea) */}
      {!bubbleOnly && (
        <div className={`${styles.card} ${dark ? styles.cardDark : ""}`}>
          <h3 className={styles.cardTitle}>
            {label || t("newHome.assistant")}
          </h3>
          <div className={styles.row}>
            <img className={styles.avatar} src={avatar} alt="" />
            <div>
              <p className={styles.name}>{assistant.title}</p>
              <p className={styles.hint}>{t("newHome.assistantHint")}</p>
            </div>
          </div>
          <button type="button" className={styles.cta} onClick={openChat}>
            {t("newHome.talkTo", { name: assistant.title })}
          </button>
        </div>
      )}

      {/* Burbuja flotante */}
      <button
        type="button"
        className={styles.bubble}
        onClick={openChat}
        aria-label={t("newHome.assistant")}
        title={assistant.title}
      >
        <img src={avatar} alt="" />
      </button>

      {/* Panel de chat */}
      {open && (
        <div className={styles.overlay} onClick={() => setOpen(false)}>
          <div className={styles.panel} onClick={(e) => e.stopPropagation()}>
            <div className={styles.panelHead}>
              <img src={avatar} alt="" />
              <strong>{assistant.title}</strong>
              <button
                type="button"
                className={styles.close}
                onClick={() => setOpen(false)}
                aria-label="x"
              >
                ✕
              </button>
            </div>
            <div className={styles.panelBody}>
              {failed ? (
                <div className={styles.connecting}>
                  {t("newHome.assistantError")}
                  <button
                    type="button"
                    className={styles.retry}
                    onClick={connect}
                  >
                    {t("newHome.retry")}
                  </button>
                </div>
              ) : loading || !threadId ? (
                <div className={styles.connecting}>
                  {t("newHome.assistantLoading")}
                </div>
              ) : (
                <AssistantEducaChat
                  assistantId={assistant.id}
                  avatarImg={avatar}
                  saludo={assistant.title}
                  threadId={threadId}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
